import React from 'react'
import { Box, IconButton, Tooltip, Chip } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { renderReportTypeChips } from './reports.utils'

export function buildColumns(onDelete, canDeleteReports) {
    const statusOptions = [
        { label: 'Pending Assign', value: 'pending_assign' },
        { label: 'Pending Doc Sent', value: 'pending_doc_sent' },
        { label: 'Pending Doc Rec', value: 'pending_doc_rec' },
        { label: 'Pending Payment', value: 'pending_payment' },
        { label: 'Pending Release', value: 'pending_release' },
        { label: 'Closed', value: 'closed' }
    ]

    const columns = [
        { field: 'emailReceivedOnFmt', headerName: 'Email Received', width: 130 },
        { field: 'companyName', headerName: 'Company', width: 220 },
        { field: 'fye', headerName: 'FYE', width: 120 },
        { field: 'personInChargeName', headerName: 'PIC', width: 160 },
        { field: 'dueDateFmt', headerName: 'Due', width: 110 },
        {
            field: 'status',
            headerName: 'Status',
            width: 160,
            editable: true,
            type: 'singleSelect',
            valueOptions: statusOptions,
            renderCell: (params) => {
                const v = params.value || 'pending_assign'
                const label = statusOptions.find(o => o.value === v)?.label || v
                return <Chip size="small" label={label} variant="outlined" />
            }
        },

        { field: 'companySecretary', headerName: 'Company Secretary', width: 180, editable: true },
        { field: 'taxAgent', headerName: 'Tax Agent', width: 160, editable: true },

        {
            field: 'reportTypes',
            headerName: 'Report Type',
            width: 220,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', minHeight: '100%' }}>
                    {renderReportTypeChips(params.row?.reportTypes, params.row?.xbrlService)}
                </Box>
            )
        },

        { field: 'sentToClientDateFmt', headerName: 'Sent', width: 110 },
        { field: 'signedReceivedDateFmt', headerName: 'Signed', width: 110 },

        { field: 'nextFollowUpDate', headerName: 'Follow-up', width: 140, editable: true },

        { field: 'totalOutstandingFmt', headerName: 'Outstanding', width: 130 }
    ]

    if (canDeleteReports) {
        columns.push({
            field: 'actions',
            headerName: '',
            width: 70,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation()
                            onDelete(params.row)
                        }}
                    >
                        <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )
        })
    }

    return columns
}